<template>
  <div class="dashboard1">
    <div class="card" v-for="card in cards2" :key="card.id" :class="getCardClass(card.item)" @click="item(card.item)">
      <div class="card-icon">
        <h2>{{ card.title }}</h2>
      </div>
      <div class="card-info1">
        <p>{{ card.count }}</p>
      </div>
    </div>
  </div>
  <br>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  name: "PermohonPengguna",
  components: {
        GChart
  },
  props: {
    auth: [Array, Object],
  },
  data() {
    return {
      cards: [
        { id: 1, title: 'Jumlah Pengguna', count: 1500, icon: 'fas fa-users' },
        { id: 2, title: 'Pengguna Aktif', count: 1200, icon: 'fas fa-user-check' },
        { id: 3, title: 'Pengguna Baru', count: 300, icon: 'fas fa-user-plus' },
        { id: 4, title: 'Pengguna Baru', count: 300, icon: 'fas fa-user-plus' },
        { id: 5, title: 'Pengguna Baru', count: 300, icon: 'fas fa-user-plus' },
      ],
      cards2:[],
    }
  },
  methods:{
    getData(id){
      if(this.$zutil.role('1'))
      {
        var role_id = 1;
        this.$zcomm.get(this.api_service + 'dashboard/pemohon-pengguna'+'?role_id='+role_id, {}).then(res => {
          this.cards2 = res
        })
      }else if(this.$zutil.role('4')){
        var role_id = 4;
        this.$zcomm.get(this.api_service + 'dashboard/pemohon-pengguna'+'?role_id='+role_id+'&user_id='+this.auth.id, {}).then(res => {
          this.cards2 = res
        })
      }else{
        var role_id = 0;
        this.$zcomm.get(this.api_service + 'dashboard/pemohon-pengguna'+'?role_id='+role_id, {}).then(res => {
          this.cards2 = res
        })
      }
    },
    item(id){
      window.location.href = window.route('administration.user.index')+'?peranan='+id;
    },
    getCardClass(id) {
      return `card-${id}`;
    },
  },
      
  mounted() {
    this.getData()
  }
}
      

</script>  
<style type="text/css">
  .dashboard1 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  padding: 20px;
  background-color: #f5f5f5;
}

.card {
  background: linear-gradient(135deg, #42a5f5, #478ed1);
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
}

.card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.card-icon {
  font-size: 60px;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s;
}

.card:hover .card-icon {
  color: #fff;
}

.card-info1 h2 {
  margin: 0;
  font-size: 18px;
  margin-right: 95px;
  font-weight: bold;
  color: #f1f1f1;
  letter-spacing: 1px;
}

.card-info1 p {
  margin-top: 8px;
  margin-right: 95px;
  font-size: 60px;
  font-weight: bold;
  color: #fff;
}
.card-2 {
  background: linear-gradient(135deg, rgb(71 247 80 / 36%), rgb(50 148 54)), url(/images/peternak.png) center / cover no-repeat;
}
.card-3 {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(254 154 26)), url(/images/benih.png) center / cover no-repeat;
}
.card-4 {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(237 30 90)), url(/images/negri.png) center / cover no-repeat;
}
.card-6 {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(244 109 104)), url(/images/pendaftar.png) center / cover no-repeat;
}
.card-5 {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(161 136 58)), url(/images/pengurus-ladang.png) center / cover no-repeat;
}
.card-7 {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(68 130 173)), url(/images/jurusuntik-ai.png) center / cover no-repeat;
}
.card-8 {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(69 164 109)), url(/images/jurusuntik-ei.png) center / cover no-repeat;
}
.card-9 {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(61 172 143)), url(/images/juruteknik-ai.png) center / cover no-repeat;
}
.card-10 {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(149 154 71)), url(/images/juruteknik-ei.png) center / cover no-repeat;
}


</style>
